import KokosilClientInterface from './kokosil-client-interface'

// localStorageの使用可否
// https://developer.mozilla.org/ja/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API
const lsAvailable = (() => {
  const storage = window.localStorage

  try {
    const x = '__storage_test__'
    storage.setItem(x, x)
    storage.removeItem(x)
    return true
  } catch(e) {
    return e instanceof DOMException &&
      (
        // everything except Firefox
        e.code === 22 ||
        // Firefox
        e.code === 1014 ||
        // test name field too, because code might not be present
        // everything except Firefox
        e.name === 'QuotaExceededError' ||
        // Firefox
        e.name === 'NS_ERROR_DOM_QUOTA_REACHED'
      ) &&
      // acknowledge QuotaExceededError only if there's something already stored
      storage.length !== 0
  }
})()

const getStorageAvailable = () => KokosilClientInterface.isAvailable() || lsAvailable

const getStorageItem = (keyName) => {
  if (KokosilClientInterface.isAvailable()) {
    return KokosilClientInterface.getContext(keyName)
  } else if (lsAvailable) {
    return window.localStorage.getItem(keyName)
  }
  return null
}

const setStorageItem = (keyName, keyValue) => {
  if (KokosilClientInterface.isAvailable()) {
    return KokosilClientInterface.setContext(keyName, keyValue)
  } else if (lsAvailable) {
    return window.localStorage.setItem(keyName, keyValue)
  }
  return null
}

export {
  getStorageAvailable,
  getStorageItem,
  setStorageItem,
}
